import Tippy from '@tippyjs/react';
import React, { useEffect, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import ModalSped from '~/components/ModalSped';
import { InputSelect } from '~/components/NovosInputs';
import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';
import ToggleDefault from '~/components/ToggleDefault';
import { tipoNaoIncidente } from '~/pages/Produto/constants';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { useProdutoQueries } from '~/pages/Produto/hooks/useQueriesProduto';
import { FlagsState } from '~/pages/Produto/types/index';
import { MapeamentoValores } from '../../../../types';
import { InputSped } from '../../SpedInput';

export const AbaPisCofins: React.FC = () => {
  const {
    register,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
    clearErrors,
    handleChangeValoresCst,
    desabilitarBuscaModal,
    enableModalSped,
    handleChangeEnabledModal,
    flags,
    ChangeFlags,
  } = useProduto();

  const { pisCofins } = useProdutoQueries();

  const tipoNaoPisCofinsAtual = watch('tipo_nao_pis_cofins');
  const tipoNaoPisCofinsAnteriorRef = useRef<any>(tipoNaoPisCofinsAtual);

  useEffect(() => {
    tipoNaoPisCofinsAnteriorRef.current = tipoNaoPisCofinsAtual;
  }, [tipoNaoPisCofinsAtual]);

  return (
    <>
      <Row>
        <Col sm={12} md={4} lg={3} xl={2}>
          <ToggleDefault
            labelText={'N\u00E3o Incidente PIS-Cofins?'}
            setChecked={flags.flg_nao_pis_cofins}
            onSwitch={() => {
              ChangeFlags((prev: FlagsState) => ({
                flg_nao_pis_cofins: !prev.flg_nao_pis_cofins,
              }));
              setValue('tipo_nao_pis_cofins', { label: '', value: undefined });
              setValue('des_sped', '');
              setValue('cod_sped', '');
              setValue('cod_tabela', '');
              setValue('reset_pis_cofins', true);
              handleChangeValoresCst('-1' as keyof MapeamentoValores);
              clearErrors('cod_sped');
              clearErrors('tipo_nao_pis_cofins');
            }}
          />
        </Col>
        <Col sm={12} md={4} lg={3} xl={3}>
          <InputSelect
            label={'Tipo N\u00E3o Incidente'}
            placeholder="Selecione o motivo"
            name="tipo_nao_pis_cofins"
            register={register}
            isError={!!errors.tipo_nao_pis_cofins}
            control={control}
            options={tipoNaoIncidente as SelectType[]}
            isDisabled={!flags.flg_nao_pis_cofins}
            changeSelected={(selected) => {
              const tipoAnterior = tipoNaoPisCofinsAnteriorRef.current;
              setValue('tipo_nao_pis_cofins', selected);

              if (tipoAnterior?.value === selected?.value) return;

              setValue('des_sped', null);
              setValue('cod_sped', null);
              setValue('cod_tabela', null);
              handleChangeValoresCst(selected.value as keyof MapeamentoValores);
              clearErrors('tipo_nao_pis_cofins');
              clearErrors('cod_sped');
            }}
          />
        </Col>
        <Col sm={12} md={4} lg={6} xl={7}>
          <InputSped
            control={control}
            isError={!!errors.cod_sped}
            showIcon
            disabledIcon={desabilitarBuscaModal()}
            onClickIcon={handleChangeEnabledModal}
          />
        </Col>
      </Row>
      <ModalSped
        enabledModalSped={enableModalSped}
        handleChangeEnabledModal={handleChangeEnabledModal}
        register={register}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <Row>
        <Col sm={12} md={6} lg={3} xl={3}>
          <InputSelect
            label="Entrada PIS/COFINS"
            name="entrada_pis_cofins"
            register={register}
            options={pisCofins.data as SelectType[]}
            isError={false}
            control={control}
            changeSelected={(selected) => {
              setValue('entrada_pis_cofins', selected);
            }}
          />
        </Col>
        <Col sm={12} md={6} lg={3} xl={3}>
          <InputSelect
            label="CST Entrada"
            name="cst_entrada"
            isDisabled
            register={register}
            isError={false}
            control={control}
            changeSelected={(selected) => {
              setValue('cst_entrada', selected);
            }}
            options={[]}
          />
        </Col>
        <Col sm={12} md={6} lg={3} xl={3}>
          <InputSelect
            label={'CST Sa\u00EDda'}
            name="cst_saida"
            register={register}
            isError={false}
            control={control}
            isDisabled
            changeSelected={(selected) => {
              setValue('cst_saida', selected);
            }}
            options={[]}
          />
        </Col>
        <Col sm={12} md={6} lg={3} xl={3} style={{ marginTop: '0.625rem' }}>
          <Tippy
            placement="top"
            content={'Opera\u00E7\u00E3o sujeita a LC n\u00BA 224/2025'}
            arrow
            animation="scale"
          >
            <div style={{ width: 'fit-content' }}>
              <ToggleDefault
                labelText="Lei Complementar 224/2025 ?"
                setChecked={Boolean(flags.flg_lei_complementar_224)}
                onSwitch={() => {
                  ChangeFlags((prev: FlagsState) => ({
                    flg_lei_complementar_224: !prev.flg_lei_complementar_224,
                  }));
                }}
              />
            </div>
          </Tippy>
        </Col>
      </Row>
    </>
  );
};
